import type { NavigateFunction } from 'react-router-dom';
import type { UpdateAgendaRecordRes, UpdateWithNestedListRes } from 'types';
import { getRedirectTarget } from './record';
import { externalRedirect } from './externalRedirect';
import { trackRecordReturnToForRedirect } from './recordReturnTo';

type RecordResponse = UpdateAgendaRecordRes | UpdateAgendaRecordRes[] | UpdateWithNestedListRes | undefined;

export const handleRedirectActions = (response: RecordResponse, navigate: NavigateFunction, openInNewTab = false): boolean => {
  if (!response) {
    return false;
  }

  if (Array.isArray(response)) {
    if (response.length === 0) {
      return false;
    }
    response.forEach((res) => handleRedirectActions(res, navigate, true));
    return true;
  }

  const mainRecordResponse = 'mainRecord' in response ? response.mainRecord : response;
  const nestedRecordsResponse = 'nestedRecords' in response ? response.nestedRecords : [];

  nestedRecordsResponse.forEach((record) => {
    handleRedirectActions(record, navigate, true);
  });

  const { redirectAction, redirectExternalAction } = mainRecordResponse;

  if (redirectExternalAction) {
    if (openInNewTab) {
      window.open(redirectExternalAction.link, '_blank', 'noopener,noreferrer');
    } else {
      externalRedirect(redirectExternalAction.link);
    }
    return true;
  }

  if (redirectAction) {
    const redirectTarget = getRedirectTarget(redirectAction);
    if (redirectTarget) {
      if (openInNewTab) {
        window.open(redirectTarget, '_blank', 'noopener');
      } else {
        trackRecordReturnToForRedirect(redirectTarget);
        navigate(redirectTarget, { replace: true });
      }
      return true;
    }
  }

  return false;
};
